import type {
  PieceAssignmentErrorReport,
  PieceAssignmentErrorReportArrayResponse,
  PieceAssignmentErrorReportResponse,
  UpsertPieceAssignmentErrorReportRequest,
} from '@apiContract';

import { receivedDigitalApi } from './index';

const pieceAssignmentErrorReportApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getPieceAssignmentErrorReportsByPiece: builder.query<PieceAssignmentErrorReport[], number>({
      query: (pieceId) => `PieceAssignmentErrorReport/piece/${pieceId}`,
      providesTags: ['PieceAssignmentErrorReport'],
      transformResponse: (response: PieceAssignmentErrorReportArrayResponse) => response.objectData,
    }),
    upsertPieceAssignmentErrorReport: builder.mutation<
      PieceAssignmentErrorReport,
      UpsertPieceAssignmentErrorReportRequest
    >({
      query: (requestData) => ({
        url: 'PieceAssignmentErrorReport',
        method: 'PUT',
        body: requestData,
      }),
      invalidatesTags: ['PieceAssignmentErrorReport'],
      transformResponse: (response: PieceAssignmentErrorReportResponse) => response.objectData,
    }),
  }),
});

export const { useGetPieceAssignmentErrorReportsByPieceQuery, useUpsertPieceAssignmentErrorReportMutation } =
  pieceAssignmentErrorReportApi;
